// Contentful returns protocol-relative URLs (//...); ensure they load locally and in all environments
function normalizeAssetUrl(url) {
	if (typeof url !== "string") return url;
	return url.startsWith("//") ? `https:${url}` : url;
}

export default normalizeAssetUrl;